// ═══ 데스크톱 뷰포트 훅 — 검차 셸 C1 재구성 (신고 371 §8) ═══
// simple.css 의 1024/1200 브레이크포인트와 같은 기준. 데스크톱 분기는 **이 두 훅으로만** 연다
// (≤768 모바일 렌더 트리 무변경 원칙 — matchMedia 가 없으면 false = 현행 렌더).
import { useState, useEffect } from 'react';

var DESKTOP = '(min-width: 1024px)';
var WIDE = '(min-width: 1200px)';

// utils/useMobile.js 와 같은 패턴 — 첫 렌더의 MediaQueryList 에 change 를 건다.
function useMedia(query) {
  var mq = typeof window !== 'undefined' && window.matchMedia ? window.matchMedia(query) : null;
  var st = useState(mq ? mq.matches : false);
  var on = st[0], set = st[1];
  useEffect(function () {
    if (!mq) return undefined;
    var handler = function (e) { set(e.matches); };
    if (mq.addEventListener) mq.addEventListener('change', handler);
    else mq.addListener(handler);
    return function () {
      if (mq.removeEventListener) mq.removeEventListener('change', handler);
      else mq.removeListener(handler);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return on;
}

/// ≥1024 — 2-pane·드롭다운 등 데스크톱 재구성 전체의 게이트.
export function useIsDesktop() { return useMedia(DESKTOP); }

/// ≥1200 — 목록 패널 440px 구간(1024~1199 는 360px). 폭 자체는 CSS 가 정한다.
export function useIsWideDesktop() { return useMedia(WIDE); }
